globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Public = appCustomerSpace.Modals.Public || {};

appCustomerSpace.Modals.Public.DealsShowroom = (function(superClass) {

  utils.extend(DealsShowroom, superClass);

  function DealsShowroom($html) {
    this.$html = $html;
    this.$innerContent = $html.find(".modal-inner-content"); // Can't use modal-content there are event bound to it by Bootstrap
    this.$body = $html.find(".modal-body");
    this.isPaymentFrequencyStep = this.$innerContent.hasClass("modal-payment_frequency-step");
    this.isSummaryStep = this.$innerContent.hasClass("modal-summary-step");
    this.isPaymentStep = this.$innerContent.hasClass("modal-payment-step");
    this.isDealsSelectionStep = this.$innerContent.hasClass("modal-deals_selection-step");
    this.isFinishedStep = this.$innerContent.hasClass("modal-finished-step");
    this.$submitBtn = this.$html.find('.modal-footer button[type="submit"]');
    this.$signDealBtn = $("body").find(".deal-payment-btn"); // Outside of modal
    this.defaults = {
      summary: {
        submit_btn: {
          text: "Signer le contrat...",
          icon: "fa-check"
        }
      },
      payment: {
        submit_btn: {
          text: "Procéder au paiement",
          icon: "fa-credit-card"
        }
      },
      dealsSelection: {
        submit_btn: {
          text: "Signer les devis...",
          icon: "fa-check"
        }
      }
    }

    return DealsShowroom.__super__.constructor.apply(this, arguments);
  }

  $.extend(DealsShowroom.prototype, {
    init: function() {
      var modal = this;

      if(modal.isSummaryStep) {
        modal.submitEvents();
        modal.summaryInit();
      }
      if(modal.isPaymentFrequencyStep) {
        modal.submitEvents();
      }
      if(modal.isPaymentStep) {
        modal.paymentInit();
      }
      if(modal.isDealsSelectionStep) {
        modal.submitEvents();
        modal.dealsSelectionInit();
      }
      if (modal.isFinishedStep) {
        modal.finishedEvents();
      }

      modal.toggleDealBtnStatus();
      modal.closeEvents();
    },
    summaryInit: function() {
      var modal = this;
          modal.$consentCheckbox = modal.$html.find("input[name='deals_showroom_sign_deals[set_deals_as_won]']");

      appCustomerSpace.Modules.ButtonCollapsable.init(modal.$html);
      appCustomerSpace.LimitlessPlugins.Checkbox.init(modal.$html);

      modal.$consentCheckbox.on("change", function() {
        modal.toggleSubmitBtn($(this).is(":checked"));
      });
    },
    paymentInit: function() {
      var modal = this;
          modal.$iframe = modal.$html.find("#iframe-container");
          modal.$wizardProgress = modal.$html.find(".step.current .progress-bar");
          modal.$developmentSignDealsBtn = modal.$html.find("a.dev-sign-deals");

      appCustomerSpace.Modules.PlatformPaymentIframe.init(modal.$iframe, {
        messageCodesCallback: function(code) {
          if(code == "101") modal.$wizardProgress.css("width", "50%");
        },
        messageTypesCallback: function(type) {
          if(type == "SUCCESS") modal.paymentHandleSuccess();
        }
      });

      modal.$submitBtn.on("click", function() {
        appCustomerSpace.Loader().start({ $container: modal.$body, options: { style: { backdrop: { background: "#FFF" } } } })

        $.ajax({
          url: $(this).data("ajax-url"),
          method: "GET",
          success: function(data) {
            modal.callbackSuccess(data);
          }
        });
      });

      modal.$developmentSignDealsBtn.on("click", function(e) {
        e.preventDefault();
        var $btn = $(this);

        $btn.find("i").removeClass("fa-credit-card").addClass("fa-spin fa-spinner");

        $.ajax({
          url: $btn.data("ajax-url"),
          method: "POST",
          success: function(data) {
            if(data.response == 1) {
              $btn.find("i").removeClass("fa-spin fa-spinner").addClass("fa-check");
              modal.toggleSubmitBtn(true);
              modal.paymentHandleSuccess();
            }
          }
        });
      });
    },
    dealsSelectionInit: function() {
      var modal = this;
          modal.$consentCheckbox = modal.$html.find("input[name='deals_showroom_sign_deals[set_deals_as_won]']");
          modal.$formRows = modal.$html.find("tr.form-tr");
          modal.$tableInputs = modal.$html.find("input[name='deals_showroom_sign_deals[selected_deals][]']")

      modal.$formRows.on("click", function(e) {
        var $row = $(this),
            $targetInput = modal.$html.find(`input[value=${$row.data("target-input")}]`);

        if ($(e.target).is("input[type='checkbox']")) {
          $row.toggleClass("active bg-primary-light");
          return;
        }

        $targetInput.prop('checked', !$targetInput.prop('checked'));
        $.uniform.update($targetInput);
        $row.toggleClass("active bg-primary-light");

        modal.toggleSubmitBtn(
          [modal.$consentCheckbox.is(":checked"), (modal.$tableInputs.filter(':checked').length >= 1)].every(Boolean)
        );
      });

      modal.$consentCheckbox.on("change", function() {
        modal.toggleSubmitBtn(
          [modal.$consentCheckbox.is(":checked"), (modal.$tableInputs.filter(':checked').length >= 1)].every(Boolean)
        );
      });
    },
    paymentHandleSuccess: function() {
      var modal = this;

      modal.$wizardProgress.css("width", "100%");
      modal.paymentRemoveSignDealBtn();
      modal.toggleSubmitBtn(true);
    },
    paymentRemoveSignDealBtn: function() {
      var modal = this;
      if(modal.$signDealBtn.length) modal.$signDealBtn.remove();
    },
    toggleDealBtnStatus: function() {
      var modal = this;

      if(!modal.$signDealBtn.length) return false;
      if(modal.isPaymentStep) modal.$signDealBtn.find("span").text(modal.defaults.payment.submit_btn.text);
      if(modal.isSummaryStep) modal.$signDealBtn.find("span").text(modal.defaults.summary.submit_btn.text);
      if(modal.isDealsSelectionStep) modal.$signDealBtn.find("span").text(modal.defaults.dealsSelection.submit_btn.text);
    },
    toggleSubmitBtn: function(boolean) {
      var modal = this;
          modal.$submitBtnTooltip = modal.$submitBtn.parent();

      if(!modal.$submitBtn.length) return false;

      if(boolean) {
          if(modal.$submitBtn.is("a")) modal.$submitBtnTooltip.removeClass("cursor-not-allowed");
          modal.$submitBtn.removeAttr("disabled");
          modal.$submitBtnTooltip.addClass("no-tooltip");
      } else {
          if(modal.$submitBtn.is("a")) modal.$submitBtnTooltip.addClass("cursor-not-allowed");
          modal.$submitBtn.attr("disabled", "disabled");
          modal.$submitBtnTooltip.removeClass("no-tooltip");
      }

      appCustomerSpace.LimitlessPlugins.Tooltip.init(modal.$html);
    },
    // Overrides of main modal.js
    submitEvents: function() {
      var modal = this;

      modal.$form.on('submit', function() {
        if (modal.$form.data('ajax') != undefined && modal.$form.data('ajax') == false) return;

        appCustomerSpace.Loader().start({ $container: modal.$body, options: { style: { backdrop: { background: "#FFF" } }, text: "Signature en cours..." } })

        modal.submit();
        return false;
      });
    },
    finishedEvents: function () {
      var modal = this;

      modal.$html.on('hidden.bs.modal', function () {
        window.location.reload();
      });
    },
    callbackSuccess: function(data, successMsg) {
      var modal = this;

      if(data && data.response == 1 && data.html) {
        modal.$innerContent.replaceWith($(data.html));
        new appCustomerSpace.Modules.NotificationFlash($(data.notification_flash));
        new appCustomerSpace.Modals.Public.DealsShowroom(modal.$html).init();
      } else {
        appCustomerSpace.Loader().error({ $container: modal.$body, options: { style: { backdrop: { background: "#FFF" } }, error: { persisted: true } } });
      }
    }
  });

  return DealsShowroom;

})(appCustomerSpace.Modal);
